import axios from 'axios';
import {
  requestOnFulfilled,
  requestOnRejected,
  responseOnFulfilled,
  responseOnRejected,
} from './_common';

const papi = axios.create({
  baseURL: PAPI_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

papi.interceptors.request.use(requestOnFulfilled, requestOnRejected);
papi.interceptors.response.use(responseOnFulfilled, responseOnRejected);

export default papi;
